<template>
  <div>
    <v-form ref="form" v-model="areFormRulesRespected">
      <v-card class="px-8 pt-3 pb-1">
        <v-layout wrap>
          <v-flex xs12>
            <h2 class="mt-4">{{ $t('a') }}</h2>    
          </v-flex>
        </v-layout>
        <div v-if="!isSuccess">
          <v-layout wrap mt-8>
            <v-flex xs5>
              <v-text-field v-model="currentPassword" dense outlined type="password" :label="$t('b')" :rules="[currentPasswordRules]" :disabled="isSavingPending"/>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-space-between>
            <v-flex xs5>
              <v-text-field v-model="password" dense outlined type="password" :label="$t('c')" :rules="[passwordRules]" :disabled="isSavingPending"/>
            </v-flex>
            <v-flex xs5>
              <v-text-field v-model="password2" dense outlined type="password" :label="$t('d')" :rules="passwordRules2" :disabled="isSavingPending"/>
            </v-flex>
          </v-layout>
          <v-layout wrap mt-2 mb-6 justify-center>
            <v-flex xs4 v-if="isSavingPending">
              <v-progress-linear indeterminate color="primary"></v-progress-linear>
            </v-flex>
            <v-flex xs12 text-center v-else>
              <v-btn @click="save" :disabled="!areFormRulesRespected || isSavingPending" class="secondary">{{ $t('e') }}</v-btn>
              <div class="red--text mt-2">{{ errorMessage }}</div>
            </v-flex>
          </v-layout>
        </div>
        <div v-else>
          <v-layout wrap>
            <v-flex xs12 text-center my-6 class="secondary--text">
              <span><v-icon color="secondary">check</v-icon><br>{{ $t('f') }}</span>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-form>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
const firebase = require('firebase');

export default {
  data: () => ({
    areFormRulesRespected: false,
    currentPassword: null,
    password: null,
    password2: null,
    errorMessage: '',
    isSavingPending: false,
    isSuccess: false
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
    passwordRules2() {
      return [
        () => this.password === this.password2 || this.$t('j'),
        v => !!v || this.$t('k'),
        v => !!v && v.length >= 6 || this.$t('l')
      ]
    }
  },
  methods: {
    currentPasswordRules(v) {
      if (!v) return this.$t('g')
      return true
    },
    passwordRules(v) {
      if (!v) return this.$t('h')
      if (!v || v.length < 6 ) return this.$t('i')
      return true
    },
    async save() {
      const _this = this
      this.errorMessage = ''
      this.isSavingPending = true
      
      const user = this.$auth.currentUser;

      const credentialForReauthentication = firebase.auth.EmailAuthProvider.credential(this.user.data.email, this.currentPassword);
      user.reauthenticateWithCredential(credentialForReauthentication).then(function() {
        user.updatePassword(_this.password).then(function() {
          _this.isSuccess = true
          _this.isSavingPending = false
        }).catch(function(error) {
          _this.isSavingPending = false
          console.error(error); // eslint-disable-line
        if (error.code === 'auth/wrong-password') _this.errorMessage = _this.$t('m')
        if (error.code === 'auth/too-many-requests') _this.errorMessage = _this.$t('n')
        else _this.errorMessage = error.message
        });
      }).catch(function(error) {
        console.error(error); // eslint-disable-line
        _this.isSavingPending = false
        if (error.code === 'auth/wrong-password') _this.errorMessage = _this.$t('m')
        if (error.code === 'auth/too-many-requests') _this.errorMessage = _this.$t('n')
        else _this.errorMessage = error.message
      });
    }
  },
}
</script>

<style scoped>
  .reset-password-container {
    margin-top: 5vh
  }
</style>

<i18n>
{
  "fr": {
    "a": "Changer votre mot de passe",
    "b": "Votre mot de passe actuel",
    "c": "Nouveau mot de passe",
    "d": "Confirmez le nouveau mot de passe",
    "e": "Sauvegarder",
    "f": "Mise à jour du mot de passe réussie.",
    "g": "Votre mot de passe actuel est requis.",
    "h": "Votre mot de passe est requis.",
    "i": "Votre mot de passe doit contenir au moins 6 caractères.",
    "j": "Les mots de passe entrés doivent être identiques.",
    "k": "Votre mot de passe est requis.",
    "l": "Votre mot de passe doit contenir au moins 6 caractères.",
    "m": "Le mot de passe actuel est erroné.",
    "n": "L'accès à ce compte a été temporairement désactivé suite à un nombre trop élevé de tentatives de changement de mot de passe. Merci de réessayer plus tard."
  },
  "en": {
    "a": "Change password",
    "b": "Old password",
    "c": "New password",
    "d": "Confirm new password",
    "e": "Update password",
    "f": "Your password has been successfully updated.",
    "g": "Your current password is required.",
    "h": "Your password is required.",
    "i": "Your password must contain at least 6 characters.",
    "j": "The two new passwords must be identical.",
    "k": "Your password is required.",
    "l": "Your password must contain at least 6 characters.",
    "m": "Your current password is incorrect.",
    "n": "Access to this account has been temporarily disabled due to many failed attempts to change password. Please try again later."
  }
}
</i18n>